import { BiographyVariables, parseBiographyVariables } from '@/utils/biographyParser';

// Build seed anchors from parsed biography variables without exposing private names
export const buildSeedAnchors = (variables: BiographyVariables): string[] => {
  const anchors: string[] = [];

  // Places
  const places = [...(variables.locations.home || []), ...(variables.locations.favorite_places || []), ...(variables.locations.work || [])]
    .filter(Boolean)
    .slice(0, 3);
  anchors.push(...places.map(p => `place:${p}`));

  // Work roles/contexts
  const roles = [...(variables.work.job_title || []), ...(variables.work.company || [])]
    .filter(Boolean)
    .slice(0, 2);
  anchors.push(...roles.map(r => `work:${r}`));

  // Relationships (no proper names)
  if ((variables.names.family || []).length > 0) anchors.push('relationship:family_support');
  if ((variables.names.pets || []).length > 0) anchors.push('relationship:pet_companion');
  if ((variables.names.friends || []).length > 0) anchors.push('relationship:friendship');

  // Hobbies / rituals
  (variables.hobbies || []).slice(0, 2).forEach(h => anchors.push(`hobby:${h}`));

  // Values / identity
  (variables.values || []).slice(0, 2).forEach(v => anchors.push(`value:${v}`));

  // Coping mechanisms
  (variables.coping_mechanisms || []).slice(0, 2).forEach(c => anchors.push(`coping:${c}`));

  // Goals & victories (keep high-level)
  if ((variables.goals.personal || []).length > 0) anchors.push('goal:personal_growth');
  if ((variables.victories || []).length > 0) anchors.push('strength:past_victory');

  // Deduplicate and limit
  return Array.from(new Set(anchors)).slice(0, 7);
};

// Evaluate how many anchors from the biography appear in the generated text
export const evaluateAnchorIntegration = (text: string, biography: string) => {
  const variables = parseBiographyVariables(biography || '');
  const seeds = buildSeedAnchors(variables);
  const lower = (text || '').toLowerCase();

  const anchorsUsed = seeds.filter(seed => {
    const token = seed.split(':')[1] || seed;
    return token && lower.includes(token.toLowerCase());
  });

  return {
    anchorCount: anchorsUsed.length,
    anchorsUsed
  };
};
